import { 
  Component, 
  EventEmitter, 
  Input, 
  Output, 
  OnInit, 
  OnChanges, 
  SimpleChanges,
  ChangeDetectionStrategy,
  inject,
  signal,
  computed
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-web-view',
  imports: [],
  templateUrl: './web-view.html',
  styleUrl: './web-view.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WebView implements OnInit, OnChanges {
  private readonly sanitizer = inject(DomSanitizer);

  @Input() iberoViewUrl!: string;
  @Output() closeIframeEvent = new EventEmitter<void>();

  // Signals
  protected readonly iframeSrc = signal<SafeResourceUrl | null>(null);
  protected readonly isLoading = signal<boolean>(true);
  protected readonly hasError = signal<boolean>(false);

  // Computed
  protected readonly isReady = computed(() => 
    this.iframeSrc() !== null && !this.hasError()
  );

  ngOnInit(): void {
    if (this.iberoViewUrl) {
      this.updateIframeSrc(this.iberoViewUrl);
    } else {
      console.warn('WebView: No URL provided');
      this.hasError.set(true);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['iberoViewUrl'] && !changes['iberoViewUrl'].firstChange) {
      const newUrl = changes['iberoViewUrl'].currentValue;
      if (newUrl) {
        this.updateIframeSrc(newUrl);
      }
    }
  }

  private updateIframeSrc(url: string): void {
    try {
      this.isLoading.set(true);
      this.hasError.set(false);
      const sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      this.iframeSrc.set(sanitizedUrl);
      console.log('WebView: URL loaded successfully');
    } catch (error) {
      console.error('WebView: Error loading URL', error);
      this.hasError.set(true);
    } finally {
      this.isLoading.set(false);
    }
  }

  protected onIframeLoad(): void {
    this.isLoading.set(false);
    console.log('WebView: Iframe loaded');
  }

  protected onIframeError(): void {
    this.isLoading.set(false);
    this.hasError.set(true);
    console.error('WebView: Iframe failed to load');
  }

  protected closeIframe(): void {
    this.closeIframeEvent.emit();
  }
}